import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  root: {
    width: '82%',
    padding: '3% 3%',
    margin: 'auto',
  },
  title: {
    fontFamily: 'Helvetica Neue LT Std',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: '18px',
    lineHeight: '22px',
    alignItems: 'center',
    marginTop: '34px',
    color: '#DF0C36',
    marginBottom: 7,
  },
  contentPaper: {
    margin: '0px !important',
    borderTop: '2px solid #DF0C36',
  },
  description: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '18px 48px',
    position: 'static',
    width: '80%',
    background: '#FAFAFA',
    borderRadius: '2px',
    flex: 'none',
    order: 0,
    flexGrow: 1,
    margin: '30px 0px 0px 60px',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '14px',
    lineHeight: '20px',
    color: '#666666',
  },
  iframe: {
    margin: '30px 60px 30px 60px',
  },
}));
